import React, { useMemo } from 'react';
import IconAndTextComponent from '../components/IconAndTextComponent';
import CardTitle from '../components/CardTitle';
import Grid from '../../muiComponents/Grid';
import GridChild from '../../muiComponents/GridChild';
import { useAccountInformation } from '../../contexts/AccountInformationContext';
import { ProfileViewMode } from '../../types/profile/profileTypes';
import InfoIcon from '../../components/InfoIcon';
import {
    singleXL_DoubleLG_ColumnGrid,
    gridSpacing40,
    gridSpacing30,
    doubleXL_ColumnGrid,
} from '../../utils/commonVariables/grid';

const ReadOnlyView = () => {
    const { accountInfo, handleViewModeChange } = useAccountInformation();

    const ownerTypeNames = useMemo(() => {
        const main = accountInfo.OwnerType;
        const rest = accountInfo.OwnerTypes.map(
            ownerType =>
                ownerType.LocalizedCaption ||
                ownerType.Caption ||
                ownerType.Name
        );
        return [main, ...rest.filter(name => name !== main)];
    }, [accountInfo.OwnerTypes]);

    return (
        <>
            <CardTitle
                title={accountInfo.Name}
                onChangeViewMode={() =>
                    handleViewModeChange(ProfileViewMode.EDIT)
                }
                label={'property_name'}
            />
            <Grid
                style={{ width: 'auto', margin: 0 }}
                columnSpacing={gridSpacing30}
                rowSpacing={gridSpacing40}
            >
                <GridChild gridProps={singleXL_DoubleLG_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'Badge'}
                        text={accountInfo.ContactPerson}
                        description={'contact_person'}
                        fontWeight={'700'}
                    />
                </GridChild>
                <GridChild gridProps={singleXL_DoubleLG_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'PhoneAndroid'}
                        text={accountInfo.Phone}
                        description={'phone'}
                    />
                </GridChild>
                <GridChild gridProps={singleXL_DoubleLG_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'Email'}
                        text={accountInfo.Email}
                        description={'your_email'}
                    />
                </GridChild>
                <GridChild gridProps={singleXL_DoubleLG_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'LocationOn'}
                        text={accountInfo.Country}
                        description={'Country'}
                    />
                </GridChild>
                <GridChild gridProps={singleXL_DoubleLG_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'Payments'}
                        text={accountInfo.Currency}
                        description={'currency'}
                        titleButtonbar={
                            accountInfo.IdCurrency ? (
                                <InfoIcon tooltipText='currency_readonly' />
                            ) : undefined
                        }
                    />
                </GridChild>
                <GridChild gridProps={singleXL_DoubleLG_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'CorporateFare'}
                        text={accountInfo?.HotelChain}
                        description={'hotel_chain'}
                        titleButtonbar={
                            <InfoIcon tooltipText='hotel_chain_readonly' />
                        }
                    />
                </GridChild>
                <GridChild gridProps={doubleXL_ColumnGrid}>
                    <IconAndTextComponent
                        icon={'Work'}
                        text={ownerTypeNames}
                        description={'access_type'}
                    />
                </GridChild>
            </Grid>
        </>
    );
};

export default ReadOnlyView;
